import React, { useState } from "react";

/* Bootstrap Components */
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Container from "react-bootstrap/Container";
/* Others */
import logo from "../../../assets/logo-latamchequea.png";
import { Link } from "react-scroll";

import { IoLogoWhatsapp } from "react-icons/io";
import {
  FaTwitter,
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";
import Modal from "react-modal";
import { FaRegWindowClose } from "react-icons/fa";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from "react-share";

/* Styled */
import {
  StyleBrand,
  StyledUlSocial,
  WrapperHeader,
  StyledScroll,
} from "./styled";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Header = (props, { deviceType }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  function openModal() {
    setIsOpen(true);
    handleSetActive();
  }

  function closeModal() {
    setIsOpen(false);
  }

  function handleSetActive() {
    const element = document.getElementById("responsive-navbar-nav");
    element.classList.remove("show");
  }

  function handleSetInactive() {
    const element = document.getElementById("responsive-navbar-nav");
    element.classList.remove("show");
  }

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        fixed="top"
        variant="light"
        bg="light"
      >
        <WrapperHeader fluid={true}>
          <Row>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="m-2"
              style={{ paddingRight: "0" }}
            >
              <StyleBrand>
                <a href="https://chequeado.com/latamchequea/">
                  <img
                    src={logo}
                    className="img-responsive"
                    width="250px"
                    alt="logo"
                  />
                </a>
              </StyleBrand>
            </Col>
          </Row>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            style={{ outline: "0" }}
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto" style={{ marginRight: "auto" }}></Nav>
            <Nav>
              <StyledUlSocial>
                <li>
                  <Link
                    activeClass="active"
                    to="agenda"
                    spy={true}
                    smooth={true}
                    onSetActive={handleSetActive}
                    onSetInactive={handleSetInactive}
                  >
                    Schedule
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="speakers"
                    spy={true}
                    smooth={true}
                    onSetActive={handleSetActive}
                    onSetInactive={handleSetInactive}
                  >
                    Attendees
                  </Link>
                </li>
                {/* <li className="d-block d-lg-none">
                  <a onClick={openModal}>Participantes</a>
                </li> */}

                 <li>
                    <Link
                      activeClass="active"
                      to="posts"
                      spy={true}
                      smooth={true}
                      onSetActive={handleSetActive}
                    >
                      Notes
                    </Link>
                  </li> 
                <li>
                  <Link
                    activeClass="active"
                    to="nuestros-asociados"
                    spy={true}
                    smooth={true}
                    onSetActive={handleSetActive}
                  >
                    Allies
                  </Link>
                </li>
                <li>
                  <a href="https://chequeado.com/latamchequeaedicionesanteriores-en">
                  Previous editions
                  </a>
                </li>
                <li>
                  <a href="mailto:latamchequea@chequeado.com">Contact</a>
                </li>
                <div className="icons">
                  <li>
                    <FacebookShareButton
                      url={`https://chequeado.com/latamchequea2022`}
                    >
                      <FaFacebook size={25} />
                    </FacebookShareButton>
                  </li>
                  <li>
                    <TwitterShareButton
                      url={`https://chequeado.com/latamchequea2022`}
                      title={"LatamChequea"}
                    >
                      <FaTwitter size={25} />
                    </TwitterShareButton>
                  </li>
                  <li>
                    <LinkedinShareButton
                      url={`https://chequeado.com/latamchequea2022`}
                    >
                      <FaLinkedin size={25} />
                    </LinkedinShareButton>
                  </li>
                  <li>
                    <WhatsappShareButton
                      url={`https://chequeado.com/latamchequea2022`}
                    >
                      <IoLogoWhatsapp size={25} />
                    </WhatsappShareButton>
                  </li>
                </div>
              </StyledUlSocial>
            </Nav>
          </Navbar.Collapse>
        </WrapperHeader>
      </Navbar>
      {/* <Row>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <Row>
            <Container>
              <Col lg={12} className="mx-auto">
                <Row>
                  <Col style={{ textAlign: "right" }}>
                    <FaRegWindowClose
                      onClick={closeModal}
                      style={{
                        color: "#354052",
                        fontSize: "20px",
                        marginRight: "5px",
                        verticalAlign: "sub",
                        cursor: "pointer",
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col
                    style={{
                      textAlign: "center",
                      marginBottom: "20px",
                      fontWeight: "bold",
                      color: "#dc4157",
                    }}
                  >
                    Participantes
                  </Col>
                </Row>
                <Row>
                  <StyledScroll
                    lg={12}
                    className="mx-auto"
                    style={{
                      height: "500px",
                      overflowY: "auto",
                      textalign: "justify",
                    }}
                  >
                    <Row>
                      <Col lg={12}>
                        {props.data?.map((el) => (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                marginBottom: "40px",
                              }}
                            >
                              <img
                                src={el.url_img}
                                class="rounded-circle mx-auto"
                                style={{ width: "99px" }}
                                alt="perfiles"
                              />
                            </div>

                            <p
                              style={{
                                lineHeight: "12px",
                                textAlign: "left",
                                marginBottom: "15px",
                                fontWeight: "bold",
                                marginTop: "2px",
                              }}
                            >
                              {el.nombre}
                            </p>
                            <p
                              style={{
                                lineHeight: "22px",
                                textAlign: "left",
                                marginBottom: "15px",
                              }}
                            >
                              {el.perfil}
                            </p>
                          </>
                        ))}
                      </Col>
                    </Row>
                  </StyledScroll>
                </Row>
              </Col>
            </Container>
          </Row>
        </Modal>
      </Row> */}
    </>
  );
};

export default Header;
